module.exports = __webpack_public_path__ + "static/media/1000960.4b6b814f.png";